import { TextProps } from '@chakra-ui/react';
import { Text } from 'components/UI';

type FieldErrorProps = TextProps & {
  error?: string;
};

const FieldError = ({ error, ...props }: FieldErrorProps) => {
  if (!error) return null;

  return (
    <Text color="black" fontSize={13} my={1.5} {...props}>
      {error}
    </Text>
  );
};

export default FieldError;
